<template>
  <div class="header-box">
    <p class="icon" @click="handleGoBack"><img class="back-icon" src="@/assets/img/my/back-icon.png" alt="" /></p>
    <p class="title">{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: 'MyHeader',
  props: {
    title: String,
    beforeGoBack: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleGoBack() {
      if (this.beforeGoBack) {
        const result = this.beforeGoBack();

        if (result instanceof Promise) {
          result.then((canGoBack) => {
            if (canGoBack) {
              this.goBack();
            }
          });
        } else if (result) {
          this.goBack();
        }
      } else {
        this.goBack();
      }
    },
    goBack() {
      if (this.$route.path === '/customer') {
        this.$router.push({
          path: '/my',
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.header-box {
  width: 100%;
  height: 64px;
  display: inline-flex;
  align-items: center;

  .icon {
    width: 60px;
    height: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    margin-left: 15px;

    .back-icon {
      width: 50px;
      height: 50px;
    }
  }

  .title {
    width: 100%;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #222222;
    text-align: center;
    margin-right: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyHeader/MyHeader.vue